import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Star, Quote } from 'lucide-react';

const LandingTestimonials = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');

  const TESTIMONIALS = [
    { quote: t('landing.testimonial1'), author: t('landing.testimonial1Author'), role: t('landing.testimonial1Role'), emoji: '💛' },
    { quote: t('landing.testimonial2'), author: t('landing.testimonial2Author'), role: t('landing.testimonial2Role'), emoji: '🚀' },
    { quote: t('landing.testimonial3'), author: t('landing.testimonial3Author'), role: t('landing.testimonial3Role'), emoji: '✨' },
  ];

  const PRESS = ['TechCrunch', 'Product Hunt', 'Mashable', 'The Verge', 'Wired'];

  return (
    <section className="py-20 sm:py-28 px-4 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-2">{t('landing.lovedByFamilies')}</p>
          <h2 className="text-3xl sm:text-4xl font-bold">{t('landing.whatParentsSay')}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((testimonial, i) => (
            <Card key={i} className="border-border/50 hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6 space-y-4 relative">
                <Quote className="h-8 w-8 text-primary/15 absolute top-4 end-4" />
                <div className="flex gap-1">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <p className="text-sm leading-relaxed italic">"{testimonial.quote}"</p>
                <div className={`flex items-center gap-3 pt-2 border-t border-border/50 ${isRTL ? 'flex-row-reverse' : ''}`}>
                  <span className="text-2xl w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center" aria-hidden="true">{testimonial.emoji}</span>
                  <div>
                    <p className="text-sm font-semibold">{testimonial.author}</p>
                    <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LandingTestimonials;
